(function(){
  var section = document.querySelector('section.fc-pp');
  var FCT = (window.__fcpp && window.__fcpp.t) || {};
  if(!section) return;
  var variantsScript = section.querySelector('[data-fc-variants]');
  var variants = [];
  try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
  /* Per-market stock gate (2026-09-18). Liquid ships variantId → local
     warehouse units for AU/US shoppers (GATED variants only: tracked +
     "stop selling when out of stock" + metafield present). 0 local units
     = sold out HERE even though Shopify (which sums every location) says
     available. Patching the parsed variants once means every consumer
     below — CTA label, Buy Now, local stock card, sticky bar — follows
     without knowing the rule. Missing map / unknown id = untouched. */
  var FC_GATE = (window.__fcpp && window.__fcpp.gateMap) || null;
  if (FC_GATE && typeof FC_GATE === 'object') {
    variants.forEach(function(v){
      if (Object.prototype.hasOwnProperty.call(FC_GATE, String(v.id)) && !(Number(FC_GATE[v.id]) >= 1)) v.available = false;
    });
  }

  var form = section.querySelector('[data-fc-form]');
  var idInput = section.querySelector('[data-fc-variant-id]');
  var priceEl = section.querySelector('[data-fc-price]');
  var compareEl = section.querySelector('[data-fc-compare]');
  var saveEl = section.querySelector('[data-fc-save]');
  var ctaBtn = section.querySelector('[data-fc-submit]');

  // Quantity stepper (2026-06-15): +/- buttons mutate the [name="quantity"]
  // input value. ATC FormData fetch and Buy Now native POST both read the
  // input directly, so no further integration is needed in either pipeline.
  var qtyInput = section.querySelector('[data-fc-qty-input]');
  if(qtyInput){
    section.querySelectorAll('[data-fc-qty-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var step = parseInt(btn.getAttribute('data-fc-qty-step'), 10) || 0;
        var current = parseInt(qtyInput.value, 10) || 1;
        var next = current + step;
        if(next < 1) next = 1;
        if(next > 99) next = 99;
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    qtyInput.addEventListener('input', function(){
      var v = parseInt(qtyInput.value, 10);
      if(isNaN(v) || v < 1) qtyInput.value = 1;
      else if(v > 99) qtyInput.value = 99;
    });
  }
  // Star-rating → review widget scroll (2026-07-19): the Judge.me app block
  // renders as #judgeme_product_reviews. Native anchor jump fails silently if
  // the widget mounts late or the id changes, so intercept and resolve the
  // target at click time with a class-based fallback.
  var reviewsLink = section.querySelector('[data-fc-reviews-link]');
  if(reviewsLink && reviewsLink.getAttribute('href').charAt(0) === '#'){
    reviewsLink.addEventListener('click', function(e){
      var target = document.querySelector(reviewsLink.getAttribute('href')) ||
                   document.querySelector('.jdgm-rev-widg, .jdgm-widget-container, #shopify-block-judge_me_reviews_review_widget');
      if(!target) return; // no widget on page — let the browser do its thing
      e.preventDefault();
      var header = document.querySelector('sticky-header, .header-wrapper');
      var offset = header ? header.getBoundingClientRect().height + 12 : 12;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  var installmentEl = section.querySelector('[data-fc-installment]');
  var installmentKEl = section.querySelector('[data-fc-installment-k]');
  var installmentPEl = section.querySelector('[data-fc-installment-p]');

  // Apply the sitewide announcement-bar discount to a price (cents in, cents
  // out). When the sale is off or no state has loaded yet, returns the input
  // unchanged. Used by the Afterpay / Klarna / PayPal "or 4×" installment
  // lines so they reflect the actual checkout total, not the pre-discount price.
  function getDiscountedCents(cents){
    var s = window.fcAnnDiscountState;
    if(s && s.enabled && s.pct > 0){
      return Math.round(cents * (100 - s.pct) / 100);
    }
    return cents;
  }
  function paintInstallments(cents){
    var quarter = moneyPlain(Math.ceil(getDiscountedCents(cents) / 4));
    if(installmentEl) installmentEl.textContent = quarter;
    if(installmentKEl) installmentKEl.textContent = quarter;
    if(installmentPEl) installmentPEl.textContent = quarter;
  }

  // ── Variant engine ──
  // Use the WITH_CURRENCY format so variant-change updates keep the AUD/USD/
  // GBP suffix that the Liquid-rendered initial price shows. Without this,
  // changing variant on AU stores would silently drop the "AUD" label and
  // look like a USD amount.
  // Formatting comes from snippets/fc-money.liquid, which derives the active
  // MARKET's pattern from a Liquid-rendered sample. The old code asked for
  // window.Shopify.money_format / .formatMoney -- both are undefined on this
  // storefront, so it always hit the '$' + toFixed(2) fallback and printed
  // "$17.24" to German shoppers on the Klarna/PayPal lines.
  //
  // moneyFormat keeps the currency suffix (matches the Liquid-rendered main
  // price, which uses money_with_currency); moneyPlain matches everything
  // Liquid renders with plain `money` -- compare-at, savings, installments.
  function moneyFormat(cents){
    if(typeof window.fcMoneyCur === 'function') return window.fcMoneyCur(cents);
    return '$' + (Number(cents)/100).toFixed(2);
  }
  function moneyPlain(cents){
    if(typeof window.fcMoney === 'function') return window.fcMoney(cents);
    return '$' + (Number(cents)/100).toFixed(2);
  }

  function getSelectedValues(){
    var values = [];
    section.querySelectorAll('[data-fc-option]:checked').forEach(function(inp){
      var pos = parseInt(inp.getAttribute('data-option-position'), 10);
      values[pos] = inp.value;
    });
    return values;
  }

  function findVariant(values){
    for(var i=0;i<variants.length;i++){
      var v = variants[i];
      var match = true;
      for(var j=0;j<values.length;j++){
        if(values[j] !== undefined && v.options[j] !== values[j]){ match = false; break; }
      }
      if(match) return v;
    }
    return null;
  }

  var modelPrefix = (window.__fcpp && window.__fcpp.modelPrefix) || 'Galaxy';
  var modelPrefixLc = modelPrefix.toLowerCase();
  // Color-set gallery: option index of "Color", or -1 when the feature is off.
  var FC_COLOR_IDX = (window.__fcpp && typeof window.__fcpp.colorIdx === 'number') ? window.__fcpp.colorIdx : -1;
  // Device-family filter (2026-09-11): index of the Model option, or -1.
  var FC_MODEL_IDX = (window.__fcpp && typeof window.__fcpp.modelIdx === 'number') ? window.__fcpp.modelIdx : -1;
  function fcDeviceOf(modelValue){ return /iphone/i.test(String(modelValue || '')) ? 'iphone' : 'galaxy'; }
  function cleanModelValue(v){
    return v.replace(/^Samsung Galaxy\s+/i, '').replace(/^Samsung\s+/i, '');
  }
  function updateSelectedLabel(){
    section.querySelectorAll('.fc-pp__option').forEach(function(optWrap){
      var sel = optWrap.querySelector('[data-fc-selected]');
      var checked = optWrap.querySelector('[data-fc-option]:checked');
      if(!sel || !checked) return;
      var v = checked.value;
      if(optWrap.classList.contains('fc-pp__option--model')){
        var clean = cleanModelValue(v);
        // Apple values ("iPhone Duo") must never get the "Galaxy" prefix.
        sel.textContent = (clean.toLowerCase().indexOf(modelPrefixLc) !== -1 || /iphone/i.test(clean)) ? clean : (modelPrefix + ' ' + clean);
      } else {
        sel.textContent = v;
      }
    });
    syncColorChipImages();
  }
  // Colour chip heroes follow the selected device family (2026-09-11): each
  // colour chip <img> carries data-fc-img-galaxy / data-fc-img-iphone (when
  // that family has a hero for the colour); pick by the selected Model.
  function syncColorChipImages(){
    if(FC_MODEL_IDX < 0) return;
    var vals = getSelectedValues();
    if(vals[FC_MODEL_IDX] === undefined) return;
    var dev = fcDeviceOf(vals[FC_MODEL_IDX]);
    var modelVal = String(vals[FC_MODEL_IDX]);
    section.querySelectorAll('.fc-pp__chips--color .fc-pp__chip img').forEach(function(img){
      // Exact model first (2026-09-18: Fold 8 has its own "_Z_Fold_Wide"
      // renders; the family hero is the Ultra/Fold 7 photo), then the
      // device-family hero as before.
      var want = null;
      var mapRaw = img.getAttribute('data-fc-img-map');
      if(mapRaw){
        // Liquid emits the pairs without the outer braces (brace literals trip its parser).
        try { var map = JSON.parse('{' + mapRaw + '}'); if(map && map[modelVal]) want = map[modelVal]; } catch(e){}
      }
      if(!want) want = img.getAttribute('data-fc-img-' + dev) || img.getAttribute('data-fc-img-' + (dev === 'iphone' ? 'galaxy' : 'iphone'));
      if(want && img.getAttribute('src') !== want) img.setAttribute('src', want);
    });
  }

  // Bundle Deal button + bundle sheet add follow the main button (2026-09-18):
  // both add the SELECTED case variant, so a market-sold-out variant must
  // read Sold out there too. Sheet add keeps its label while a bundle add is
  // in flight (data-fc-busy).
  function syncBundleButtons(available){
    var bdBtn = section.querySelector('[data-fc-bundle-trigger]');
    if(bdBtn){
      var bdLbl = bdBtn.querySelector('.fc-pp__cta-label');
      var bdBadge = bdBtn.querySelector('.fc-pp__cta-badge');
      if(available){
        bdBtn.removeAttribute('disabled');
        if(bdLbl) bdLbl.textContent = bdBtn.getAttribute('data-fc-bundle-label') || bdLbl.textContent;
        if(bdBadge) bdBadge.removeAttribute('hidden');
      } else {
        bdBtn.setAttribute('disabled','disabled');
        if(bdLbl) bdLbl.textContent = (FCT.soldout || 'Sold out');
        if(bdBadge) bdBadge.setAttribute('hidden','');
      }
    }
    var shBtn = section.querySelector('[data-fc-sheet-add]');
    if(shBtn && !shBtn.hasAttribute('data-fc-busy')){
      var shLbl = shBtn.querySelector('.fc-pp__cta-label');
      if(available){ shBtn.removeAttribute('disabled'); shBtn.classList.remove('is-soldout'); if(shLbl) shLbl.textContent = (FCT.atc || 'Add To Cart'); }
      else { shBtn.setAttribute('disabled','disabled'); shBtn.classList.add('is-soldout'); if(shLbl) shLbl.textContent = (FCT.soldout || 'Sold out'); }
    }
  }
  function updateUI(variant){
    if(!variant){
      if(ctaBtn){ ctaBtn.setAttribute('disabled','disabled'); ctaBtn.querySelector('.fc-pp__cta-label').textContent = (FCT.unavailable || 'Unavailable'); }
      syncBundleButtons(false);
      return;
    }
    idInput.value = variant.id;
    // Pre-order price preview (2026-09-11): mirrors the Liquid branch in
    // fc-pp-info.liquid — a Duo (preorder.match) variant inside the window
    // shows price minus preorder.pct (floored, = Shopify's allocation) with
    // the full price struck through. Reads window.__fcpp directly so it works
    // even when updateUI runs before the pre-order block below initialises.
    var poCfg = (window.__fcpp && window.__fcpp.preorder) || {};
    var poPrice = null;
    try {
      if (poCfg.match && poCfg.pct > 0 && variant.options && !(variant.compare_at_price > variant.price)) {
        var poEndT = poCfg.end ? Date.parse(poCfg.end) : NaN;
        if (isNaN(poEndT) || Date.now() <= poEndT) {
          var poM = String(poCfg.match).toLowerCase();
          for (var poI = 0; poI < variant.options.length; poI++) {
            if (String(variant.options[poI]).toLowerCase().indexOf(poM) !== -1) { poPrice = Math.floor(variant.price * (100 - poCfg.pct) / 100); break; }
          }
        }
      }
    } catch (e) { poPrice = null; }
    if(priceEl) priceEl.textContent = moneyFormat(poPrice != null ? poPrice : variant.price);
    if(compareEl && saveEl){
      if(poPrice != null){
        compareEl.textContent = moneyPlain(variant.price);
        compareEl.removeAttribute('hidden');
        var poSaveStr = moneyPlain(variant.price - poPrice);
        poSaveStr = (typeof window.fcMoneyTrim === 'function') ? window.fcMoneyTrim(poSaveStr) : poSaveStr.replace(/\.00$/, '');
        saveEl.textContent = (FCT.savePre != null ? FCT.savePre : 'SAVE ') + poSaveStr + (FCT.saveSuf || '');
        saveEl.removeAttribute('hidden');
      } else if(variant.compare_at_price && variant.compare_at_price > variant.price){
        compareEl.textContent = moneyPlain(variant.compare_at_price);
        compareEl.removeAttribute('hidden');
        var save = variant.compare_at_price - variant.price;
        var saveStr = moneyPlain(save);
        saveStr = (typeof window.fcMoneyTrim === 'function')
          ? window.fcMoneyTrim(saveStr)
          : saveStr.replace(/\.00$/, '');
        saveEl.textContent = (FCT.savePre != null ? FCT.savePre : 'SAVE ')
          + saveStr + (FCT.saveSuf || '');
        saveEl.removeAttribute('hidden');
      } else {
        compareEl.setAttribute('hidden','');
        saveEl.setAttribute('hidden','');
      }
    }
    paintInstallments(poPrice != null ? poPrice : variant.price);
    if(ctaBtn){
      if(variant.available){
        ctaBtn.removeAttribute('disabled');
        ctaBtn.querySelector('.fc-pp__cta-label').textContent = (FCT.atc || 'Add To Cart');
      } else {
        ctaBtn.setAttribute('disabled','disabled');
        ctaBtn.querySelector('.fc-pp__cta-label').textContent = (FCT.soldout || 'Sold out');
      }
    }
    // Buy Now follows the same availability (2026-09-18). It was only ever
    // set by Liquid at load, so switching to a sold-out colour left it live.
    var bnBtn = section.querySelector('[data-fc-buynow]');
    if(bnBtn && !bnBtn.hasAttribute('data-fc-busy')){
      if(variant.available) bnBtn.removeAttribute('disabled');
      else bnBtn.setAttribute('disabled','disabled');
    }
    syncBundleButtons(!!variant.available);
    // Broadcast the variant change so sibling sections can follow it
    // (2026-08-07). Only sections/main-product.liquid dispatched this, and
    // no live product template renders that section any more — which is why
    // the bundle's case image stayed on the first colour no matter what the
    // shopper picked. Same detail shape main-product used.
    try {
      var fcFeatImg = '';
      if (variant.featured_image && variant.featured_image.src) fcFeatImg = variant.featured_image.src;
      else if (variant.featured_media && variant.featured_media.preview_image) fcFeatImg = variant.featured_media.preview_image.src;
      document.dispatchEvent(new CustomEvent('fc:variant:change', {
        detail: {
          productId: (window.__fcpp && window.__fcpp.productId) || null,
          variant: variant,
          featuredImage: fcFeatImg,
          price: variant.price,
          compareAtPrice: variant.compare_at_price,
          available: !!variant.available
        }
      }));
    } catch (e) {}

    // Fold 8 / Fold 8 Ultra: swap In-stock bar for the Pre-order bar.
    syncPreorder(variant);
    // Local AU/US warehouse stock bar follows the selected variant.
    syncLocalStock(variant);
    // Keep announcement-bar discount in sync with the new variant price.
    var priceWrap = section.querySelector('.fc-pp__price[data-fc-product-price]');
    if (priceWrap) {
      priceWrap.setAttribute('data-fc-product-price', variant.price);
      priceWrap.removeAttribute('data-fc-discount-applied');
      priceWrap.removeAttribute('data-fc-orig-html');
      if (typeof window.fcAnnSyncDiscount === 'function') window.fcAnnSyncDiscount();
    }
  }

  // ── Fold 8 / Fold 8 Ultra pre-order messaging (2026-07-23) ──
  // Selected model containing "fold 8" (any casing) swaps the green In-stock
  // bar for the amber Pre-order bar; the bar toggles a floating explainer
  // panel underneath. Matches "Fold 8", "Fold 8 Ultra" and the current
  // variant-name typos ("Fold 8 Ult", "Galazy Z Fold 8").
  var preorderBar    = section.querySelector('[data-fc-preorder]');
  var preorderPanel  = section.querySelector('[data-fc-preorder-panel]');
  var preorderToggle = section.querySelector('[data-fc-preorder-toggle]');
  var preorderDeal   = section.querySelector('[data-fc-preorder-deal]');
  var preorderPill   = section.querySelector('[data-fc-preorder-pill]');
  var defaultStockEl = section.querySelector('[data-fc-stock]');
  // 2026-09-10: generalised for the iPhone Duo launch. window.__fcpp.preorder =
  // { match: 'iphone', end: ISO datetime, cta: 'Pre-order' } comes from the
  // section settings; a variant is in pre-order when any option value contains
  // `match` and the end date has not passed. The CTA label swaps to `cta`.
  var PO = (window.__fcpp && window.__fcpp.preorder) || {};
  var poMatch = PO.match ? new RegExp(String(PO.match).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : null;
  var poEnd = PO.end ? Date.parse(PO.end) : NaN;
  function isPreorderVariant(variant){
    if(!variant || !variant.options || !poMatch) return false;
    if(!isNaN(poEnd) && Date.now() > poEnd) return false;
    for(var i=0;i<variant.options.length;i++){
      if(poMatch.test(String(variant.options[i]))) return true;
    }
    return false;
  }
  function syncPreorder(variant){
    if(!preorderBar) return;
    var on = isPreorderVariant(variant);
    preorderBar.hidden = !on;
    if(ctaBtn){
      var poLbl = ctaBtn.querySelector('.fc-pp__cta-label');
      if(poLbl && on && variant && variant.available){ poLbl.textContent = (PO.cta || 'Pre-order'); ctaBtn.setAttribute('data-fc-preorder-cta',''); }
      else if(!on){ ctaBtn.removeAttribute('data-fc-preorder-cta'); }
    }
    if(preorderDeal) preorderDeal.hidden = !on;
    if(preorderPill) preorderPill.hidden = !on;
    // The stock line is hidden by default (2026-09-06) and only shows once
    // phone-detect has written a message into it — never un-hide it empty.
    if(defaultStockEl){
      if(on) defaultStockEl.hidden = true;
      else if(defaultStockEl.getAttribute('data-fc-detect-state')) defaultStockEl.hidden = false;
    }
    if(!on){
      if(preorderPanel) preorderPanel.hidden = true;
      if(preorderToggle) preorderToggle.setAttribute('aria-expanded','false');
      preorderBar.removeAttribute('data-open');
    }
  }
  if(preorderToggle){
    preorderToggle.addEventListener('click', function(){
      var opening = preorderPanel && preorderPanel.hidden;
      if(preorderPanel) preorderPanel.hidden = !opening;
      preorderToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if(opening){ preorderBar.setAttribute('data-open','true'); }
      else { preorderBar.removeAttribute('data-open'); }
    });
  }
  // Initial state — the page can load with a Fold 8 variant preselected
  // (e.g. ?variant= links from the Fold 8 collection pages).
  /* ── Local warehouse stock bar (2026-08-21) ──────────────────────────
     Rendered by fc-pp-info.liquid for AU/US buyers only, with a
     variantId -> local units map (from the custom.stock_au / stock_us
     metafields, which mirror the real per-warehouse inventory levels).
     Everything here is presentation; the two promises that must never be
     wrong are re-checked per variant:
       • sold out (variant.available false) → hide
       • Fold 8 pre-order variant           → hide, that bar promises weeks
     A missing map or unknown variant also hides the bar rather than
     guessing, so a sync gap degrades to silence, never to a false claim. */
  var lsBar   = section.querySelector('[data-fc-localstock-bar]');
  var lsLabel = lsBar && lsBar.querySelector('[data-fc-ls-label]');
  var lsFrom  = lsBar && lsBar.querySelector('[data-fc-ls-from]');
  var lsHero  = lsBar && lsBar.querySelector('[data-fc-ls-hero]');
  var lsFill  = lsBar && lsBar.querySelector('[data-fc-ls-fill]');
  var lsD0    = lsBar && lsBar.querySelector('[data-fc-ls-d0]');
  var lsD1    = lsBar && lsBar.querySelector('[data-fc-ls-d1]');
  var lsD2    = lsBar && lsBar.querySelector('[data-fc-ls-d2]');
  var lsMap   = null;
  var lsDatesDone = false;
  if (lsBar) {
    var lsJson = section.querySelector('[data-fc-localstock]');
    if (lsJson) { try { lsMap = JSON.parse(lsJson.textContent); } catch (e) { lsMap = null; } }
  }
  /* Shipping promise line under the title (shown when a product has <5
     reviews). AU/US buyers see "Free Australia Shipping" / "Free US
     Shipping" while the selected variant has local stock — the exact
     condition that shows the delivery card — and the worldwide default
     otherwise. Other markets never carry data-fc-ship-local, so this is a
     no-op for them. */
  var lsShipEl = section.querySelector('[data-fc-ship-promise]');
  function lsSetShipPromise(local){
    if (!lsShipEl) return;
    var txt = local ? lsShipEl.getAttribute('data-fc-ship-local') : null;
    if (!txt) txt = lsShipEl.getAttribute('data-fc-ship-default') || 'Free worldwide shipping';
    if (lsShipEl.textContent !== txt) lsShipEl.textContent = txt;
    var wrap = lsShipEl.closest('.fc-pp__rating--promise');
    if (wrap) wrap.setAttribute('aria-label', txt);
  }
  /* Delivery route dates (2026-09-06). Computed from the SHOPPER'S clock,
     never Liquid — product pages are page-cached so a Liquid "today" goes
     stale. Business days = Mon–Fri; an order placed on a weekend starts
     counting from Monday. Public holidays are not excluded. */
  function lsAddBusinessDays(from, n){
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function lsIso(d){
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  function lsFmt(d){
    var lang = (document.documentElement.getAttribute('lang') || 'en');
    try {
      return d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) {
      var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var mons = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return days[d.getDay()] + ' ' + d.getDate() + ' ' + mons[d.getMonth()];
    }
  }
  function lsSetDate(el, d){
    if (!el) return;
    el.textContent = lsFmt(d);
    el.setAttribute('datetime', lsIso(d));
  }
  function lsRenderDates(){
    if (lsDatesDone || !lsBar) return;
    var dispatch = parseInt(lsBar.getAttribute('data-fc-ls-dispatch'), 10);
    var delivery = parseInt(lsBar.getAttribute('data-fc-ls-delivery'), 10);
    if (!isFinite(dispatch) || dispatch < 0) dispatch = 1;
    if (!isFinite(delivery) || delivery < 1) delivery = 4;
    if (dispatch >= delivery) dispatch = Math.max(0, delivery - 1);
    var today = new Date();
    var arrives = lsAddBusinessDays(today, delivery);
    lsSetDate(lsD0, today);
    lsSetDate(lsD1, lsAddBusinessDays(today, dispatch));
    lsSetDate(lsD2, arrives);
    lsSetDate(lsHero, arrives);
    lsDatesDone = true;
    // Let the panel paint first so the route fill animates in.
    if (lsFill) {
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ lsBar.classList.add('is-live'); }); });
    }
  }
  function syncLocalStock(variant){
    if (!lsBar) return;
    /* Suppress only when a pre-order message is ACTUALLY rendered and visible
       on this page. Keying off the variant name alone was wrong: the pre-order
       bar markup lives in sections/main-product.liquid, which no active product
       renders — every product uses fc-pp-info, whose buy box just says "In
       stock". So the name check silently hid the bar on every Fold 8 variant
       while nothing was contradicting it. syncPreorder() runs immediately
       before this, so .hidden is current. */
    var preorderShowing = !!(preorderBar && !preorderBar.hidden);
    // 2026-09-10: `allowPreorder` was never declared (latent ReferenceError that
    // only fired once a pre-order bar could actually render). It mirrors the
    // section's "Also show alongside a pre-order bar" setting.
    var allowPreorder = lsBar.getAttribute('data-fc-ls-preorder') === 'true';
    if (!lsMap || !variant || !variant.available || (preorderShowing && !allowPreorder)) {
      lsBar.hidden = true;
      lsSetShipPromise(false);
      return;
    }
    // Local (AU or US warehouse) units for THIS variant. The map only exists
    // for AU/US buyers (Liquid gate), and a missing/zero/negative value means
    // no local stock → the whole panel stays hidden. Never fall back to the
    // global inventory total here.
    var qty = Object.prototype.hasOwnProperty.call(lsMap, String(variant.id)) ? Number(lsMap[variant.id]) : NaN;
    if (!isFinite(qty) || qty < 1) {
      lsBar.hidden = true;
      lsSetShipPromise(false);
      return;
    }
    qty = Math.floor(qty);
    lsSetShipPromise(true);
    var where = lsBar.getAttribute('data-fc-ls-where') || '';
    // Stock is a plain live number in the chip — the route below is the
    // delivery timeline, not a stock gauge.
    var state, label;
    if (qty <= 3)      { state = 'critical'; label = 'Only ' + qty + ' left'; }
    else if (qty <= 9) { state = 'low';      label = 'Only ' + qty + ' left'; }
    else               { state = 'good';     label = qty + ' in stock'; }
    lsBar.setAttribute('data-state', state);
    if (lsLabel) lsLabel.textContent = label;
    if (lsFrom)  lsFrom.textContent = 'Ships from ' + where;
    lsRenderDates();
    lsBar.hidden = false;
  }

  syncPreorder(findVariant(getSelectedValues()));
  syncLocalStock(findVariant(getSelectedValues()));

  section.querySelectorAll('[data-fc-option]').forEach(function(inp){
    inp.addEventListener('change', function(){
      updateSelectedLabel();
      var values = getSelectedValues();
      var variant = findVariant(values);
      updateUI(variant);
      // Color-set gallery: narrow slides/thumbs to the selected color's set
      // BEFORE the featured-image navigation below, so it lands on a visible
      // slide. No-op when the feature is off (FC_COLOR_IDX = -1).
      if((FC_COLOR_IDX > -1 && values[FC_COLOR_IDX] !== undefined) || FC_MODEL_IDX > -1){
        var filterGal = section.querySelector('[data-fc-gallery]');
        if(filterGal && typeof filterGal._fcApplyColorFilter === 'function'){
          filterGal._fcApplyColorFilter(FC_COLOR_IDX > -1 ? values[FC_COLOR_IDX] : '');
        }
      }
      // Switch main gallery image to the variant's featured image.
      // Two paths because product variants on this store use TWO different
      // image-attachment systems:
      //   1) variants whose featured_image IS in product.media → navigate to
      //      that slide via _fcShowByImageId (handled inside the gallery scope)
      //   2) variants whose featured_image was uploaded via legacy product.images
      //      and is NOT synced to product.media (common when a variant-image
      //      app like Bold or Globo uploaded them) → fall back to overriding
      //      the currently-visible slide's <img src> directly with the variant
      //      image URL. Less ideal than a true gallery navigation but gives
      //      immediate visual feedback that the swatch click worked.
      if(variant && variant.featured_image){
        var galleryEl = section.querySelector('[data-fc-gallery]');
        if(galleryEl){
          var found = false;
          if(typeof galleryEl._fcShowByImageId === 'function'){
            found = galleryEl._fcShowByImageId(variant.featured_image.id);
            // featured_image.id is a ProductImage id which never matches the
            // MediaImage ids on data-media-id (and data-image-id renders
            // empty on this store) — retry with featured_media.id, which
            // does. Critical for the color-set gallery, where the legacy
            // paint-slide-0 fallback below could target a hidden slide.
            if(!found && variant.featured_media){
              found = galleryEl._fcShowByImageId(variant.featured_media.id);
            }
          }
          if(!found){
            // Fallback: legacy variant image not in product.media — paint it
            // onto the active slide.
            var srcUrl = variant.featured_image.src || variant.featured_image.url;
            if(srcUrl){
              if(srcUrl.indexOf('//') === 0) srcUrl = 'https:' + srcUrl;
              // Navigate to slide 0 first so we always overwrite the same one
              // (otherwise repeated variant clicks paint over whichever slide
              // happens to be active).
              if(typeof galleryEl._fcShowSlide === 'function'){
                galleryEl._fcShowSlide(0);
              }
              var activeSlide = galleryEl.querySelector('.fc-pp__slide.is-active')
                              || galleryEl.querySelector('.fc-pp__slide');
              if(activeSlide){
                var img = activeSlide.querySelector('img');
                if(img){
                  img.src = srcUrl;
                  img.removeAttribute('srcset');
                  if(variant.featured_image.alt){
                    img.alt = variant.featured_image.alt;
                  }
                }
              }
              // Also paint over the first thumb so it reflects the active color
              var firstThumb = galleryEl.querySelector('.fc-pp__thumb[data-idx="0"] img');
              if(firstThumb){
                firstThumb.src = srcUrl;
                firstThumb.removeAttribute('srcset');
              }
            }
          }
        }
      }
    });
  });

  // ── Device-family fallback from the referring collection (2026-09-10) ──
  // Liquid scopes the model chips when the URL is /collections/<h>/products/…
  // (window.__fcpp.ctx). Bare /products/ URLs reached from a collection page
  // (cached grid HTML, older links, back/forward) get the same treatment here
  // from document.referrer: a Galaxy collection hides iPhone chips, an iPhone
  // collection hides Galaxy chips. Direct/search/ad traffic is left untouched.
  (function applyReferrerFamily(){
    try {
      if (window.__fcpp && window.__fcpp.ctx) return;               // Liquid already scoped
      var ref = document.referrer || '';
      if (!ref) return;
      var a = document.createElement('a'); a.href = ref;
      if (a.host !== location.host) return;
      var m = a.pathname.match(/\/collections\/([^\/?#]+)/);
      if (!m) return;
      var h = decodeURIComponent(m[1]).toLowerCase();
      var fam = '';
      if (h.indexOf('iphone') !== -1) fam = 'iphone';
      else if (/fold|flip|galaxy|s-pen/.test(h)) fam = 'galaxy';
      if (!fam) return;
      var group = section.querySelector('.fc-pp__chips--model');
      if (!group) return;
      var wraps = Array.prototype.slice.call(group.querySelectorAll('.fc-pp__chip-wrap'));
      var kept = [], hidden = [];
      wraps.forEach(function(w){
        var isIphone = /iphone/i.test(w.getAttribute('data-value') || '');
        var hide = (fam === 'iphone') ? !isIphone : isIphone;
        if (hide) { w.style.display = 'none'; w.setAttribute('data-fc-ctx-hidden', '1'); hidden.push(w); }
        else kept.push(w);
      });
      if (!kept.length) { hidden.forEach(function(w){ w.style.display = ''; w.removeAttribute('data-fc-ctx-hidden'); }); return; }
      var checked = group.querySelector('input:checked');
      var checkedWrap = checked ? checked.closest('.fc-pp__chip-wrap') : null;
      if (!checkedWrap || checkedWrap.getAttribute('data-fc-ctx-hidden')) {
        var target = null;
        for (var i = 0; i < kept.length; i++) {
          var inp = kept[i].querySelector('input[type="radio"]');
          if (inp && !inp.disabled) { target = inp; break; }
        }
        if (target) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      if (window.__fcpp) window.__fcpp.ctx = fam;
    } catch (e) { /* never block the PDP */ }
  })();

  updateSelectedLabel();

  // ── Initial installment paint with sitewide discount applied ──
  // The Liquid template renders raw 1/4 prices at the server. If a sitewide
  // sale is active, those server-rendered values are wrong until JS overrides
  // them. We re-paint once on load, then again whenever the announcement bar
  // toggles its discount state.
  function repaintInstallmentsForCurrentVariant(){
    var values = getSelectedValues();
    var v = findVariant(values) || variants[0];
    if(v) paintInstallments(v.price);
  }
  repaintInstallmentsForCurrentVariant();
  if(!(window.fcAnnDiscountState && window.fcAnnDiscountState.enabled)){
    // fc-announcement may run after us — try again on next tick in case the
    // state lands between now and the next animation frame.
    setTimeout(repaintInstallmentsForCurrentVariant, 0);
  }
  document.addEventListener('fc:discount-changed', repaintInstallmentsForCurrentVariant);

  // ── Align main image bottom + thumb strip with Bundle Deal (desktop) ──
  // Products with more colors / models have a taller right column, which
  // leaves the gallery looking short and disconnected. We measure Bundle
  // Deal's bottom Y and STRETCH the image stage downward by the gap
  // amount — the image (object-fit:contain, max-height:90%) naturally
  // scales up to fill the larger stage, and the thumb strip (which sits
  // right below the stage via flex column + gap) gets pushed down with
  // it. Net effect: image bottom and thumb strip both align with Bundle
  // Deal, with the same tight gap Halo M1 has. Mobile is unaffected.
  (function alignGalleryWithBundle(){
    var mq = window.matchMedia('(min-width: 990px)');
    var chrome = section.querySelector('.fc-pp__chrome');
    var stage  = section.querySelector('.fc-pp__stage');
    if(!chrome || !stage) return;
    var anchor = section.querySelector('[data-fc-bundle-trigger]')
              || section.querySelector('[data-fc-submit]');
    if(!anchor) return;

    // Cap how much the image stage can grow beyond its 520px base. Without
    // a cap, products with 3 option rows (e.g. Sync M1's Model+Color+Bundle
    // or Aegis H1's many colors wrapping to 2 rows) push delta past 200px,
    // which makes the image look absurdly tall. 100px keeps the image
    // close to Halo M1's natural size while still closing most of the gap.
    var MAX_STRETCH = 100;

    function apply(){
      stage.style.height = '';
      chrome.style.marginTop = '';
      if(!mq.matches) return;
      var anchorRect = anchor.getBoundingClientRect();
      var chromeRect = chrome.getBoundingClientRect();
      var stageRect  = stage.getBoundingClientRect();
      var delta = anchorRect.bottom - chromeRect.bottom;
      if(delta <= 0) return;
      // Step 1: stretch image stage up to MAX_STRETCH. Tight image-to-thumb
      // gap preserved on moderate cases (Vanguard, Sentinel, etc.).
      var stretch = Math.min(delta, MAX_STRETCH);
      if(stretch > 0) stage.style.height = (stageRect.height + stretch) + 'px';
      // Step 2: if delta exceeds the stretch cap, push the thumb strip down
      // via margin to absorb the rest. Image stays at the capped size; a
      // small extra gap appears between image and thumbs on extreme cases.
      var remaining = delta - stretch;
      if(remaining > 0) chrome.style.marginTop = remaining + 'px';
    }

    apply();
    var raf = null;
    window.addEventListener('resize', function(){
      if(raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(apply);
    });
    // Re-run when images/fonts settle late and shift heights.
    setTimeout(apply, 200);
    setTimeout(apply, 800);
  })();

  // ── Buy Now: NATIVE form POST to /cart/add with return_to=/checkout ──
  // Earlier attempts used fetch + window.location.href, but a third-party
  // cart app (xb-sticky-add-to-cart) was either intercepting the click
  // at a higher capture phase OR a cart:updated listener was opening
  // the slide-cart faster than the redirect could complete.
  //
  // Native form.submit() triggers an immediate browser navigation that
  // CANNOT be cancelled by any JS handler. We build a hidden form with
  // the same field values as the visible product form, plus a
  // return_to=/checkout input that tells Shopify to redirect after add.
  // The browser POSTs to /cart/add, Shopify adds the item, then 302s
  // straight to /checkout. No drawer, no race conditions.
  var buyNowBtn = section.querySelector('[data-fc-buynow]');
  if (buyNowBtn && form) {
    buyNowBtn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (buyNowBtn.hasAttribute('disabled')) return;
      var label = buyNowBtn.querySelector('.fc-pp__cta-label');
      var originalText = label ? label.textContent : '';
      buyNowBtn.setAttribute('disabled','disabled');
      buyNowBtn.setAttribute('data-fc-busy','');
      if (label) label.textContent = 'Processing…';

      try {
        // Build a hidden form mirroring the visible form's values.
        var hiddenForm = document.createElement('form');
        hiddenForm.method = 'POST';
        hiddenForm.action = (window.__fcpp && window.__fcpp.cartAddUrl) || '/cart/add';
        hiddenForm.style.display = 'none';
        hiddenForm.setAttribute('enctype', 'multipart/form-data');

        var formData = new FormData(form);
        formData.forEach(function(value, key){
          // Skip File inputs (none expected on a normal product form, but
          // be defensive — appending a File to a created form input doesn't
          // round-trip cleanly).
          if (typeof value === 'string') {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            hiddenForm.appendChild(input);
          }
        });

        // return_to is the magic flag. Shopify reads this on /cart/add
        // and 302s to it after the add succeeds.
        var returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = '/checkout';
        hiddenForm.appendChild(returnInput);

        document.body.appendChild(hiddenForm);
        hiddenForm.submit();
      } catch (err) {
        // Restore button on failure to build/submit the form.
        buyNowBtn.removeAttribute('disabled');
        buyNowBtn.removeAttribute('data-fc-busy');
        if (label) label.textContent = originalText || 'Buy Now';
        if (window.console) console.warn('[fc] Buy Now failed:', err);
      }
    }, true);  // capture: true — runs before bubble-phase third-party handlers
  }

  // ── Main form ATC: /cart/add.js fetch + FoldifyCart floating toast ──
  // Previously the [data-fc-submit] button did a native form POST that
  // navigated the customer to /cart — they couldn't scroll back to see
  // the gallery, and the cart-drawer overflow:hidden side-effect could
  // leave the body in a scroll-locked state if they hit Back. This
  // intercepts the submit, fetches /cart/add.js, and shows the same
  // FoldifyCart toast the sticky-cart and bundle sheet use, so all
  // ATC paths now behave consistently and keep the customer in place.
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!ctaBtn || ctaBtn.hasAttribute('disabled')) return;
      var originalLabel = ctaBtn.querySelector('.fc-pp__cta-label');
      var originalText  = originalLabel ? originalLabel.textContent : '';
      ctaBtn.setAttribute('disabled','disabled');
      if(originalLabel) originalLabel.textContent = 'Adding…';

      // Capture scroll position BEFORE the fetch so the shared watchdog
      // can restore it after unwinding any cart-drawer scroll lock.
      var savedScrollY = window.pageYOffset || window.scrollY || 0;

      // Request Dawn cart sections so the cart-drawer can refresh its
      // contents (otherwise it'd open showing the previous cart state,
      // not the item just added). Mirrors Dawn's product-form.js pattern.
      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(r){ return r.json(); })
        .then(function(response){
          // /cart/add.js returns the line item only — no item_count. Chain
          // a /cart.js fetch so the FoldifyCart toast and header badge get
          // an accurate count.
          return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            response.item_count = cart.item_count;
            response.total_price = cart.total_price;
            return response;
          }).catch(function(){ return response; });
        })
        .then(function(response){
          if(originalLabel) originalLabel.textContent = '✓ Added';
          // Refresh + open the cart-drawer with the new line item.
          var drawer = document.querySelector('cart-drawer');
          if (drawer && response.sections && typeof drawer.renderContents === 'function'){
            drawer.renderContents(response);
            // Dawn's renderContents only strips `is-empty` from `.drawer__inner`,
            // but the CSS rule `cart-drawer.is-empty .drawer__inner { ... }`
            // is keyed on the WRAPPER. Without removing it here, the drawer
            // shows empty-state layout even when items are present (the
            // "no items in floating cart on mobile" bug).
            drawer.classList.remove('is-empty');
          } else if (drawer && typeof drawer.open === 'function'){
            drawer.open();
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
          if(window.FoldifyCart && typeof window.FoldifyCart.show === 'function'){
            window.FoldifyCart.show(response);
          }
          // Install the shared scroll-lock watchdog (5s, 50ms polling +
          // MutationObserver). Covers sync AND async lock attempts from
          // Dawn's <cart-drawer>, the cart-notification component, and
          // third-party cart apps that subscribe to cart:updated.
          if (typeof window.fcInstallScrollLockWatchdog === 'function'){
            window.fcInstallScrollLockWatchdog(savedScrollY, 5000);
          }
          setTimeout(function(){
            ctaBtn.removeAttribute('disabled');
            if(originalLabel) originalLabel.textContent = originalText || 'Add to Cart';
          }, 1200);
        })
        .catch(function(){
          ctaBtn.removeAttribute('disabled');
          if(originalLabel) originalLabel.textContent = originalText || 'Add to Cart';
        });
    });
  }

  // ── Phone-detect → In-stock bar merger (2026-06-14) ──
  // When window.fcDetectPhone fires with a detected Android model name,
  // we mutate the In stock bar's detail text from "Ships today" to
  // "Your phone is <Model>" (or "<Model> — model not stocked" if no match).
  // If the detected model matches a chip in the model picker, the inline
  // Select CTA shows up — clicking it sets the radio + scrolls the picker.
  (function detectPhoneBar(){
    var stockBar = section.querySelector('[data-fc-stock-detectable]');
    if(!stockBar) return;
    var detailEl = stockBar.querySelector('[data-fc-stock-detail]');
    var ctaBtn   = stockBar.querySelector('[data-fc-stock-cta]');
    if(!detailEl || !ctaBtn) return;

    function findMatchingChip(name){
      var nameLc = name.toLowerCase().replace(/\s+/g,' ').trim();
      var stripped = nameLc.replace(/^samsung\s+/,'').replace(/^galaxy\s+/,'');
      var modelOption = section.querySelector('.fc-pp__option--model');
      if(!modelOption) return null;
      var labels = modelOption.querySelectorAll('.fc-pp__chip-wrap');
      for(var i=0;i<labels.length;i++){
        var v = (labels[i].getAttribute('data-value') || '').toLowerCase()
          .replace(/^samsung\s+/,'').replace(/^galaxy\s+/,'').replace(/\s+/g,' ').trim();
        if(v === stripped) return labels[i];
      }
      return null;
    }

    function runDetection(){
      window.fcDetectPhone(function(name){
        if(!name) return;
        var matchChip = findMatchingChip(name);
        if(matchChip){
          detailEl.textContent = (FCT.phoneIs || 'Your phone is') + ' ' + name;
          stockBar.setAttribute('data-fc-detect-state', 'match');
          stockBar.hidden = false;
          ctaBtn.removeAttribute('hidden');
          ctaBtn.addEventListener('click', function(){
            var input = matchChip.querySelector('input[type="radio"]');
            if(!input) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', {bubbles:true}));
            matchChip.scrollIntoView({behavior:'smooth', block:'center'});
            ctaBtn.setAttribute('hidden','');
            // Reset and hide again after selection — there is no default
            // "In stock" state to fall back to any more.
            detailEl.textContent = '';
            stockBar.removeAttribute('data-fc-detect-state');
            stockBar.hidden = true;
          });
        } else {
          detailEl.textContent = name + ' ' + (FCT.notStocked || '— model not stocked yet');
          stockBar.setAttribute('data-fc-detect-state', 'nomatch');
          stockBar.hidden = false;
        }
      });
    }

    // Wait for the helper to be defined. The snippet at the top of this
    // section renders it inline so it should be available immediately,
    // but on first-paint or with deferred script loads it can lag — poll
    // up to ~3 seconds before giving up. Previous version returned
    // immediately when undefined, requiring a manual refresh to recover.
    // Android phone-detect is pointless on an iPhone-context page (no Galaxy
    // chips rendered) — it would only ever say "model not stocked".
    if (typeof window.fcDetectPhone === 'function' && !(window.__fcpp && window.__fcpp.ctx === 'iphone')) {
      runDetection();
      return;
    }
    var attempts = 0;
    var maxAttempts = 60; // 60 × 50ms = 3s
    var pollId = setInterval(function(){
      attempts++;
      if (typeof window.fcDetectPhone === 'function') {
        clearInterval(pollId);
        runDetection();
      } else if (attempts >= maxAttempts) {
        clearInterval(pollId);
      }
    }, 50);
  })();

  // ── Bundle Deal button (desktop scroll / mobile sheet) ──
  (function(){
    var trigger = section.querySelector('[data-fc-bundle-trigger]');
    var sheet = section.querySelector('[data-fc-sheet]');
    var mqMobile = window.matchMedia('(max-width: 989px)');

    // The bundle section renders AFTER this one in the page flow, so we query
    // the DOM lazily (at every call site) rather than caching a reference at
    // script-execution time — otherwise we'd capture null.
    function findBundle(){
      return document.querySelector('[data-bundle-section]') || document.querySelector('[id^="fc-pp-bundle"]') || document.querySelector('[class*="fc-pp-bundle"]');
    }

    function syncDiscount(){
      var bundleEl = findBundle();
      if(!bundleEl) return;
      var pct = bundleEl.getAttribute('data-discount') || '';
      if(!pct) return;
      section.querySelectorAll('[data-fc-bundle-pct]').forEach(function(el){el.textContent = pct;});
    }

    function scrollToBundle(){
      var bundleEl = findBundle();
      if(!bundleEl) return;
      bundleEl.scrollIntoView({behavior:'smooth', block:'center'});
    }

    function cloneItemsIntoSheet(){
      if(!sheet) return;
      var bundleEl = findBundle();
      if(!bundleEl) return;
      var itemsContainer = sheet.querySelector('[data-fc-sheet-items]');
      if(!itemsContainer || itemsContainer.childElementCount) return;
      var sourceItems = bundleEl.querySelectorAll('.fc-item');
      var checkSvg = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      sourceItems.forEach(function(src){
        if(src.getAttribute('data-placeholder') === 'true') return;
        var vid = src.getAttribute('data-variant-id') || '';
        var thumb = src.querySelector('.fc-thumb img');
        var name = src.querySelector('.fc-info__name');
        var price = src.querySelector('[data-addon-discounted-price]');
        var was = src.querySelector('[data-addon-original-price]');
        var item = document.createElement('div');
        item.className = 'fc-pp__sheet-item';
        item.setAttribute('role','button');
        item.setAttribute('tabindex','0');
        item.setAttribute('aria-pressed','false');
        if(vid) item.setAttribute('data-variant-id', vid);
        var html = '';
        if(thumb && thumb.src){
          html += '<img class="fc-pp__sheet-item-img" src="' + thumb.src + '" alt="' + (thumb.alt || '') + '" loading="lazy">';
        } else {
          html += '<span class="fc-pp__sheet-item-img" aria-hidden="true"></span>';
        }
        html += '<div class="fc-pp__sheet-item-body">';
        if(name) html += '<span class="fc-pp__sheet-item-name">' + name.textContent + '</span>';
        html += '<span class="fc-pp__sheet-item-price">';
        if(price) html += price.textContent;
        if(was && was.textContent) html += '<span class="fc-pp__sheet-item-was">' + was.textContent + '</span>';
        html += '</span></div>';
        html += '<span class="fc-pp__sheet-item-check" aria-hidden="true">' + checkSvg + '</span>';
        item.innerHTML = html;
        function toggle(){
          var on = !item.classList.contains('is-selected');
          item.classList.toggle('is-selected', on);
          item.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        item.addEventListener('click', toggle);
        item.addEventListener('keydown', function(e){
          if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); toggle(); }
        });
        itemsContainer.appendChild(item);
      });
    }

    // Scroll-lock helpers. We use the position:fixed body technique because
    // setting documentElement.style.overflow='hidden' is unreliable on iOS
    // Safari — sometimes the lock stays in effect after the sheet closes,
    // which has been the cause of "can't scroll back up to the gallery"
    // reports. Saving/restoring scrollY here keeps the visible position
    // stable across open and close.
    var _fcSavedScrollY = 0;
    function lockScroll(){
      _fcSavedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + _fcSavedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.documentElement.style.overflow = 'hidden';
    }
    function unlockScroll(){
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.documentElement.style.overflow = '';
      window.scrollTo(0, _fcSavedScrollY);
    }

    function openSheet(){
      if(!sheet) return;
      cloneItemsIntoSheet();
      syncDiscount();
      sheet.setAttribute('aria-hidden','false');
      lockScroll();
    }
    function closeSheet(){
      if(!sheet) return;
      sheet.setAttribute('aria-hidden','true');
      unlockScroll();
    }

    if(trigger){
      trigger.addEventListener('click', function(){
        if(mqMobile.matches){ openSheet(); } else { scrollToBundle(); }
      });
    }
    if(sheet){
      sheet.querySelectorAll('[data-fc-sheet-close]').forEach(function(el){
        el.addEventListener('click', closeSheet);
      });
      var addBtn = sheet.querySelector('[data-fc-sheet-add]');
      if(addBtn){
        addBtn.addEventListener('click', function(){
          if(addBtn.hasAttribute('disabled')) return;
          var items = [];
          var mainId = idInput && idInput.value;
          if(mainId) items.push({id: parseInt(mainId, 10), quantity: 1});
          sheet.querySelectorAll('.fc-pp__sheet-item.is-selected[data-variant-id]').forEach(function(it){
            var vid = parseInt(it.getAttribute('data-variant-id'), 10);
            if(vid) items.push({id: vid, quantity: 1});
          });
          if(!items.length) return;
          var originalLabel = addBtn.querySelector('.fc-pp__cta-label');
          var originalText = originalLabel ? originalLabel.textContent : '';
          addBtn.setAttribute('disabled','disabled');
          addBtn.setAttribute('data-fc-busy','');
          if(originalLabel) originalLabel.textContent = 'Adding…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({items: items})
          }).then(function(r){return r.json();}).then(function(response){
            if(originalLabel) originalLabel.textContent = '✓ Added';

            // Close the sheet + unlock scroll FIRST, before any other work.
            // Even if subsequent code throws, the user's page stays usable.
            closeSheet();

            // Notify any other subscribers (header bubble syncs via cart:updated
            // listener registered in the fc-cart-toast snippet).
            document.dispatchEvent(new CustomEvent('cart:updated', {detail: response}));
            if(typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate){
              publish(PUB_SUB_EVENTS.cartUpdate, {source: 'fc-pp-info-bundle-sheet', cartData: response});
            }

            // Show the FoldifyCase toast — self-contained, doesn't touch the
            // product page DOM, so the gallery and form stay intact.
            if(window.FoldifyCart && typeof window.FoldifyCart.show === 'function'){
              window.FoldifyCart.show(response);
            }

            setTimeout(function(){
              addBtn.removeAttribute('disabled');
              if(originalLabel) originalLabel.textContent = originalText || 'Add to Cart';
            }, 800);
          }).catch(function(){
            // On error, ALSO unlock scroll defensively — user might be stuck
            // in a half-open state otherwise.
            closeSheet();
            addBtn.removeAttribute('disabled');
            if(originalLabel) originalLabel.textContent = originalText || 'Add to Cart';
          });
        });
      }
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && sheet.getAttribute('aria-hidden') === 'false') closeSheet();
      });
    }

    // Initial discount sync — after DOM is fully parsed so the bundle section exists
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', syncDiscount);
    } else {
      syncDiscount();
    }
  })();

  // ── Gallery ──
  var gallery = section.querySelector('[data-fc-gallery]');
  if(gallery){
    var slides = gallery.querySelectorAll('.fc-pp__slide');
    var thumbs = gallery.querySelectorAll('.fc-pp__thumb');
    var thumbStrip = gallery.querySelector('.fc-pp__thumbs');
    var thumbTrack = gallery.querySelector('.fc-pp__thumb-track');
    var stage = gallery.querySelector('.fc-pp__stage');
    var curEl = gallery.querySelector('.fc-pp__cur');
    var mq = window.matchMedia('(max-width: 989px)');
    function isMobile(){return mq.matches;}
    function pad(n){return n<10?'0'+n:''+n;}
    var navPrev = gallery.querySelector('[data-fc-nav="prev"]');
    var navNext = gallery.querySelector('[data-fc-nav="next"]');
    function updateEdges(){
      // Fade indicators on the thumb strip follow actual scroll position
      if(thumbStrip && thumbTrack){
        var canLeft = thumbStrip.scrollLeft > 2;
        var canRight = thumbStrip.scrollLeft + thumbStrip.clientWidth < thumbStrip.scrollWidth - 2;
        thumbTrack.classList.toggle('has-left-more', canLeft);
        thumbTrack.classList.toggle('has-right-more', canRight);
      }
    }
    // Color-set gallery: navigation runs over the VISIBLE subset of
    // slides/thumbs (those not hidden by _fcApplyColorFilter below). With
    // the feature off nothing is ever hidden, so visibleIdx() is identity.
    function visibleIdx(){
      var out = [];
      for(var i=0;i<thumbs.length;i++){ if(!thumbs[i].classList.contains('fc-color-hidden')) out.push(i); }
      if(out.length) return out;
      for(var j=0;j<thumbs.length;j++) out.push(j);
      return out;
    }
    function updateNavDisabled(){
      var vis = visibleIdx();
      var pos = vis.indexOf(currentIndex());
      var atStart = pos <= 0;
      var atEnd = pos === -1 || pos >= vis.length - 1;
      if(navPrev){ if(atStart) navPrev.setAttribute('disabled',''); else navPrev.removeAttribute('disabled'); }
      if(navNext){ if(atEnd) navNext.setAttribute('disabled',''); else navNext.removeAttribute('disabled'); }
    }
    function currentIndex(){
      for(var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('is-active')) return i; }
      return 0;
    }
    function stepImage(dir){
      var vis = visibleIdx();
      var pos = vis.indexOf(currentIndex()) + dir;
      if(pos < 0) pos = 0;
      if(pos > vis.length - 1) pos = vis.length - 1;
      show(vis[pos]);
    }
    if(navPrev) navPrev.addEventListener('click', function(){stepImage(-1);});
    if(navNext) navNext.addEventListener('click', function(){stepImage(1);});
    function setActive(i){
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i);});
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i);});
      var aThumb = thumbs[i];
      if(aThumb && thumbStrip){
        var stripRect = thumbStrip.getBoundingClientRect();
        var aRect = aThumb.getBoundingClientRect();
        if(aRect.left < stripRect.left || aRect.right > stripRect.right){
          aThumb.scrollIntoView({behavior:'smooth', inline:'nearest', block:'nearest'});
        }
      }
      updateNavDisabled();
    }
    function show(i){
      setActive(i);
      if(isMobile() && stage){
        // Mobile stage is a horizontal scroll-snap track — hidden slides
        // leave the flow, so scroll position is the index within the
        // VISIBLE subset, not the absolute slide index.
        var w = stage.clientWidth;
        var pos = visibleIdx().indexOf(i);
        if(pos < 0) pos = i;
        stage.scrollTo({left: pos * w, behavior:'smooth'});
      }
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(e){e.preventDefault();show(i);});});
    if(thumbStrip){
      thumbStrip.addEventListener('scroll', updateEdges, {passive:true});
      window.addEventListener('resize', updateEdges);
      setTimeout(updateEdges, 100);
    }
    updateNavDisabled();
    // Expose gallery API so the variant change handler (defined earlier in this
    // IIFE, before this block runs) can switch the gallery image when a new
    // variant is selected. Bug fix 2026-05-14: clicking a variant swatch
    // previously updated price/CTA but not the main image.
    gallery._fcShowByImageId = function(imageId){
      if(!imageId) return false;
      var key = String(imageId);
      var target = gallery.querySelector('.fc-pp__slide[data-image-id="' + key + '"]')
                || gallery.querySelector('.fc-pp__slide[data-media-id="' + key + '"]');
      if(!target) return false;
      var idx = parseInt(target.getAttribute('data-idx'), 10);
      if(isNaN(idx)) return false;
      show(idx);
      return true;
    };
    gallery._fcShowSlide = show;
    // Color-set gallery: show only slides/thumbs whose data-fc-group matches
    // the selected color. "*" marks shared images (visible for every color);
    // if a color has no matching images at all, fail open and show
    // everything rather than an empty gallery.
    gallery._fcApplyColorFilter = function(colorValue){
      var want = String(colorValue || '');
      var hasSet = false;
      // Device family (2026-09-11): slides/thumbs carry data-fc-device
      // ('iphone' | 'galaxy' | '*'). Hide the OTHER family of the selected
      // Model; fail open when the product has no media of the wanted family.
      var wantDev = '', hasDev = false;
      if(FC_MODEL_IDX > -1){
        var selVals = getSelectedValues();
        if(selVals[FC_MODEL_IDX] !== undefined) wantDev = fcDeviceOf(selVals[FC_MODEL_IDX]);
      }
      thumbs.forEach(function(t){
        if(t.getAttribute('data-fc-group') === want) hasSet = true;
        if(wantDev && t.getAttribute('data-fc-device') === wantDev) hasDev = true;
      });
      function matches(el){
        var dv = el.getAttribute('data-fc-device');
        if(wantDev && hasDev && dv && dv !== '*' && dv !== wantDev) return false;
        var g = el.getAttribute('data-fc-group');
        if(!g || g === '*' || !hasSet) return true;
        return g === want;
      }
      slides.forEach(function(s){ s.classList.toggle('fc-color-hidden', !matches(s)); });
      thumbs.forEach(function(t){ t.classList.toggle('fc-color-hidden', !matches(t)); });
      var vis = visibleIdx();
      if(vis.indexOf(currentIndex()) === -1) show(vis[0]);
      updateEdges();
      updateNavDisabled();
    };
    // Initial paint: narrow to the color of the pre-selected variant (handles
    // both the default first-variant load and ?variant= deep links).
    if(FC_COLOR_IDX > -1 || FC_MODEL_IDX > -1){
      var fcInitVals = getSelectedValues();
      gallery._fcApplyColorFilter(FC_COLOR_IDX > -1 ? fcInitVals[FC_COLOR_IDX] : '');
    }
    // Land on the pre-selected variant's OWN photo (2026-09-18). The colour
    // filter above only guarantees a slide of the right colour, and its
    // first slide is the oldest one — Purple's first slide is the Fold 7 /
    // Ultra render, so a ?variant= deep link (or the AU/US local-stock
    // re-pick) for Fold 8 Purple opened on the wrong device photo while a
    // chip click navigated correctly. Same lookup the click path uses.
    try {
      var fcInitVar = findVariant(getSelectedValues());
      if(fcInitVar){
        var fcLanded = false;
        if(fcInitVar.featured_media) fcLanded = gallery._fcShowByImageId(fcInitVar.featured_media.id);
        if(!fcLanded && fcInitVar.featured_image) gallery._fcShowByImageId(fcInitVar.featured_image.id);
      }
    } catch(e){}
    // Mobile: listen to stage horizontal scroll, update active state after user swipes
    if(stage){
      var scrollT;
      stage.addEventListener('scroll', function(){
        if(!isMobile()) return;
        clearTimeout(scrollT);
        scrollT = setTimeout(function(){
          var w = stage.clientWidth;
          if(w<=0) return;
          var vis = visibleIdx();
          var pos = Math.round(stage.scrollLeft / w);
          pos = Math.max(0, Math.min(vis.length-1, pos));
          setActive(vis[pos]);
        }, 80);
      }, {passive:true});
    }
  }

  // Ship-today countdown removed 2026-06-14 — the In stock bar's detail
  // text is now phone-detect-driven instead of timer-driven.
})();
